<template>
  <div>
    <!-- In LiveMWA component props: -- selcrs- {{ sel_crs }} <br />
    chap-{{ chapter }} <br />
    typ- {{ quiztype }} <br /> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="box">
          <v-row dense justify="center">
            <v-col cols="12" sm="4">
              <b>Total Weightage - {{ total_weightage }}</b>
            </v-col>
            <!-- <v-col cols="12" sm="4">
              <p class="tx-bold">Weightage</p>
              <v-text-field
                class="p-0 m-0"
                v-model.trim="weightage"
                type="number"
                required
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <span>Question Statement :</span><br />
              <v-textarea v-model="question" @keypress="countfillinthblank()" @keyup.delete="countfillinthblank()"
                placeholder="Enter Question Statement"></v-textarea>
              <p class="note-error">
                Note: Please enter 3 minus(-) symbol simultaneously to make it a
                blank. --- indicates blanks area within the question.
              </p>
              <p class="note-text">Example : "--- is the capital of India."</p>
            </v-col>
            <v-col cols="12" sm="1" md="1"></v-col>

            <v-col cols="12" sm="3" md="3">
              <span>Answer :</span>
              <span v-for="t in dashfound" :key="t">
                <v-text-field v-model="answer[t]" @change="addans(answer[t])" placeholder="Enter Answer Text"
                  hint="Mumbai, pune"></v-text-field>
              </span>
            </v-col>
            <v-col cols="12" sm="1" md="1"></v-col>
            <v-col cols="12" sm="1" md="1">
              <span>Weightage :</span><br />
              <span v-for="t in dashfound" :key="t">
                <p></p>
                <v-text-field outlined dense type="number" v-model="option_weightage[t]"
                  @change="calculatemarks()"></v-text-field>
              </span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- {{option_weightage}}
      <v-card-actions> -->

      <v-row justify="center" v-if="this.from != 'QB'">
        <v-btn class="button" @click="showStudents()">Select Students</v-btn>
      </v-row>
      <v-row justify="center" v-if="this.from == 'QB'">
        <v-btn class="button" @click="save()">Save</v-btn>
      </v-row>
      <!-- <v-row justify="center">
        <v-btn class="button" @click="save">Save & Publish</v-btn>
      </v-row> -->
      <!-- </v-card-actions> -->
    </div>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please Wait File is Uploding...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-dialog v-model="show_studnts" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar class="toolbar">
            <v-btn icon dark @click="show_studnts = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>All Students</v-toolbar-title>
            <v-toolbar-items>
              <v-btn dark text @click="show_studnts = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card class="box">
            <v-row class="sub-row" justify="center" dense>
              <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                <v-data-table :headers="headers_students" :items="learners" :search="search" class="elevation-1"
                  show-select v-model="selected" item-key="lid" :items-per-page="-1"></v-data-table>
              </v-col>
            </v-row>
          </v-card>
          <v-row justify="center" v-if="this.from != 'QB'">
            <v-btn class="button" @click="save()">Save & Publish</v-btn>
          </v-row>
          <v-row justify="center" v-if="this.from == 'QB'">
            <v-btn class="button" @click="save()">Save</v-btn>
          </v-row>

          <v-row justify="center" dense v-if="this.selected.length > 0">
            <strong>Total Selected - {{ selected.length }}</strong>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  props: {
    chapter: Number,
    sel_crs: Array,
    quiztype: String,
    from: String,
    Level: Number,
  },
  data() {
    return {
      option_weightage: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      weightage: 1.0,
      dialog: false,
      answer: [],
      courseId: null,
      all_data: null,
      dashfound: null,
      question: null,
      basepath: "",
      ans: [],
      headers_students: [
        { text: "Sr. No.", value: "count", sortable: "true" },
        { text: "Student", value: "name" },
      ],
      learners: [],
      show_studnts: false,
      search: null,
      total_students: [],
      selected: [],
      total_weightage: 0,
    };
  },
  methods: {
    calculatemarks() {
      this.total_weightage = 0;
      for (var i = 0; i < this.option_weightage.length; i++) {
        // alert(this.option_weightage[i])
        if (this.option_weightage[i] != null) {
          this.total_weightage += parseFloat(this.option_weightage[i]);
        }
      }
    },
    showStudents() {
      if (this.question == null) {
        this.showSnackbar("#b71c1c", "Please Enter Question Statement!"); // show snackbar
        return;
      } else if ($.isEmptyObject(this.answer)) {
        this.showSnackbar("#b71c1c", "Please Enter Model Answer!"); // show snackbar
        return;
      }
      this.show_studnts = true;
      this.markAllSelected();
    },
    markAllSelected() {
      this.selected = [];
      for (let i = 0; i < this.learners.length; i++) {
        this.selected.push(this.learners[i]);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    addans(e) {
      this.ans.push(e.target.value);
      this.answer = this.ans;
    },
    countfillinthblank() {
      let text = this.question;
      let pattern = /---/g;
      let found = text.match(pattern);
      this.dashfound = found.length;
    },
    reset() {
      this.question = null;
      (this.answer = []),
        (this.total_weightage = 0),
        (this.option_weightage = []);
    },
    save() {
      this.total_weightage = 0;
      if (this.question == null) {
        alert("Enter Question Statement");
      } else if ($.isEmptyObject(this.answer)) {
        alert("Enter Model Answer or File");
      } else {
        //this.courseId = this.sel_crs[0].coff_id;
        // alert(this.from)
        let crs_id = "";
        let coi_id = [];
        if (this.from == "QB") {
          crs_id = this.sel_crs;
        } else {
          crs_id = this.sel_crs[0].coff_id;
          for (var i = 0; i < this.sel_crs.length; i++) {
            coi_id.push(this.sel_crs[i].coi_id);
          }
          for (var i = 0; i < this.selected.length; i++) {
            this.total_students.push(this.selected[i].lid);
            // formData.append("total_students", this.selected[i].lid);
          }
          if (this.total_students.length <= 0) {
            this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
          }
        }

        for (var i = 0; i < this.option_weightage.length; i++) {
          // alert(this.option_weightage[i])
          if (this.option_weightage[i] != null) {
            this.total_weightage += parseFloat(this.option_weightage[i]);
          }
        }
        //  if(this.total_weightage != this.weightage){
        //    this.showSnackbar("red", "Total Weightage Doesn't Match Question Weightage");
        //    return
        //  }
        //return
        const data = {
          question: this.question,
          weightage: this.total_weightage,
          type: this.quiztype,
          answer: this.answer,
          option_weightage: this.option_weightage,
          crs_id: crs_id,
          ch_id: this.chapter,
          Level_id: this.Level,
          coi_id: coi_id,
          from: this.from,
          total_students: this.total_students,
        };
        this.dialog = true;
        this.overlay = true;
        axios
          .post("/LiveClass/saveQuestionInBankMWA", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("green", "Question Published successfully...");
              this.reset();
              this.dialog = false;
              (this.total_students = []),
                (this.show_studnts = false),
                (this.overlay = false);
              //$(window).scrollTop($('#GFG_DOWN').position().top);
            }
          })
          .catch((error) => {
            this.showSnackbar("red", "Something went wrong..");
          })
          .finally(() => {
            this.dialog = false;
            this.overlay = false;
          });
      }
    },
  },
  mounted() {
    //  alert(this.chapter)
    //  alert(this.sel_crs)
    //  alert(this.from)
    // alert(this.quiztype)
    //console.log("sel_crs LiveMCQ", this.sel_crs);
    //this.getQuestionBank();
    this.learners = JSON.parse(localStorage.getItem("live-session-students"));
  },
};
</script>
<style scoped>
.note-error {
  color: #ff5e00;
  font-size: 16px;
}

.note-text {
  color: #c24e0b;
  font-size: 18px;
}
</style>